import { useState, useMemo, useEffect } from "react";

import {
  Box,
  Text,
  Badge,
  Container,
  Heading,
  HStack,
  VStack,
  Breadcrumb,
  BreadcrumbItem,
  FormControl,
  FormHelperText,
  CircularProgress,
  useDisclosure,
  useToast,
  Divider,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
// import Card, { getCardScheme } from "components/Card/Card";
import Input from "components/Input/Input";
import Button from "components/Button/Button";
import Select from "components/Select/Select";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import SuccessModal from "components/Modals/Success";
import SubmitPinModal from "components/Modals/SubmitPin";

// import Steps, { StepContent } from "components/Steps/Steps";
// import { useSteps } from "components/Steps/provider";

import { useHistory } from "react-router-dom";

import {
  useGetPreorderFeeQuery,
  useGetPreorderStatusQuery,
  usePreorderPhysicalCardMutation,
} from "services/cardsApi";

import isEmpty from "lodash/isEmpty";
import constant from "config/constant";
import capitalize from "lodash/capitalize";
import toCoinLocale from "util/toCoinLocale";
import toPrecision from "util/toPrecision";

import useCountries from "hooks/useCountries";
import useWalletBalance from "hooks/useWalletBalance";
import getError from "util/getError";

export default function RequestPhysicalCard(props) {
  const currentPage = "Card";

  const { userData } = props;

  console.log("USER DATA - PREORDER", userData);
  // const fee = 7;

  const toast = useToast();
  const history = useHistory();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isPinOpen,
    onOpen: onPinOpen,
    onClose: onPinClose,
  } = useDisclosure();

  //   const cards = props?.location?.state?.cards;
  //   const steps = [{ label: "Step 1" }, { label: "Step 2" }, { label: "Finish" }];

  const [state, _setState] = useState({});

  const { getBalance } = useWalletBalance();
  const { data } = useCountries();

  const { data: feeData, isLoading: isFeeLoading } = useGetPreorderFeeQuery();
  const { data: preorderStatusData, isLoading: isPreorderStatusLoading } =
    useGetPreorderStatusQuery();

  const cards = useMemo(
    () =>
      (preorderStatusData?.data?.data ?? [])?.filter(
        (card) => card?.status !== "declined"
      ),
    [preorderStatusData]
  );

  const fee = useMemo(() => feeData?.actualFee ?? 7, [feeData]);
  console.log("PREORDER", cards, feeData);

  const [
    preorderCard,
    { data: preorderData, isLoading, isError, isSuccess, error },
  ] = usePreorderPhysicalCardMutation();

  const setState = (newState) => _setState(() => ({ ...state, ...newState }));

  const handleSubmit = (e) => {
    e.preventDefault();
    onPinOpen();
  };

  const handlePreorder = () => {
    const reqData = {
      pin: state?.pin,
      coin: state?.coin,
      addressData: {
        streetNo: state?.streetNo,
        streetAddress: state?.streetAddress,
        zipCode: state?.zipCode,
        postalCode: state?.postalCode,
        city: state?.city,
        state: state?.state,
        country: state?.country,
      },
      cardDetails: {
        firstName: state?.firstname,
        lastName: state?.lastname,
        otherNames: state?.othername,
      },
    };

    // console.log("PRE-ORDER REQ DATA", reqData);
    preorderCard(reqData);
  };

  const handleSuccessModalClose = () => {
    onClose();
    history.replace("/dashboard/cards?tab=physical");
  };

  useEffect(() => {
    if (
      userData?.kycLevel !== "three" ||
      (!isEmpty(cards) && !isPreorderStatusLoading)
    ) {
      history.replace("/dashboard/cards?tab=physical");
    }
  }, [userData, cards, isPreorderStatusLoading, history]);

  useEffect(() => {
    if (isSuccess && preorderData) {
      onOpen();
    }

    if (isError && error) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isSuccess, error, preorderData, isError, onOpen, toast]);

  const balance = useMemo(
    () => getBalance(state?.coin),
    [getBalance, state?.coin]
  );

  const countries = useMemo(() => data?.data?.countries, [data]);

  //   console.log("COUNTRIES", countries);

  const isDisabled = useMemo(
    () =>
      !(
        state?.firstname &&
        state?.lastname &&
        state?.streetAddress &&
        state?.streetNo &&
        state?.postalCode &&
        state?.zipCode &&
        state?.state &&
        state?.city &&
        state?.coin &&
        state?.country
      ) ||
      isLoading ||
      balance < fee ||
      isPreorderStatusLoading,
    [state, isLoading, balance, fee, isPreorderStatusLoading]
  );

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="lg" m="0">
            <Box px={["24px", "0", "0"]}>
              <Heading fontSize="3xl">Physical Card Request</Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/cards?tab=physical">
                    Cards
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Physical Card
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <Box
              bg="white"
              border="1px solid #8688942f"
              // minH="681px"
              //   w="calc(100% - 25vw)"
              w="100%"
              mt="32px"
              borderRadius="8px"
              p="24px"
            >
              <VStack maxW="container.sm" m="0 auto">
                <Box as="form" onSubmit={handleSubmit}>
                  {/* <Card colorScheme={getCardScheme(state?.card.type)} /> */}
                  <Heading as="h4" fontSize="md" fontWeight="600">
                    Name on Card
                  </Heading>
                  <FormControl mt="20px !important">
                    <Input
                      label="Firstname"
                      placeholder="Enter firstname"
                      value={state?.firstname ?? ""}
                      onChange={(e) => setState({ firstname: e.target.value })}
                    />
                  </FormControl>
                  <FormControl mt="6px !important">
                    <Input
                      label="Othername"
                      placeholder="Enter othername (optional)"
                      value={state?.othername ?? ""}
                      onChange={(e) => setState({ othername: e.target.value })}
                    />
                  </FormControl>
                  <FormControl mt="6px !important">
                    <Input
                      label="Lastname"
                      placeholder="Enter lastname"
                      value={state?.lastname ?? ""}
                      onChange={(e) => setState({ lastname: e.target.value })}
                    />
                  </FormControl>

                  <Divider my="20px" />

                  <Heading as="h4" fontSize="md" fontWeight="600">
                    Shipping Address
                  </Heading>
                  <FormControl mt="20px !important">
                    <Input
                      label="Street"
                      placeholder="Enter street name"
                      value={state?.streetAddress ?? ""}
                      onChange={(e) =>
                        setState({ streetAddress: e.target.value })
                      }
                    />
                  </FormControl>

                  <FormControl mt="6px !important">
                    <Input
                      label="Flat No, suite, unit, building or floor number"
                      // type="number"
                      placeholder="Enter flat no..."
                      pattern="^[a-zA-Z0-9]*$"
                      value={state?.streetNo ?? ""}
                      onChange={(e) => setState({ streetNo: e.target.value })}
                    />
                  </FormControl>

                  <FormControl mt="6px !important">
                    <Input
                      label="Postal Code"
                      placeholder="Enter postal code"
                      value={state?.postalCode ?? ""}
                      onChange={(e) => setState({ postalCode: e.target.value })}
                    />
                  </FormControl>

                  <FormControl mt="6px !important">
                    <Input
                      label="Zip Code"
                      placeholder="Enter zip code"
                      value={state?.zipCode ?? ""}
                      onChange={(e) => setState({ zipCode: e.target.value })}
                    />
                  </FormControl>

                  <FormControl mt="6px !important">
                    <Input
                      label="Town/City"
                      placeholder="Enter town/city"
                      value={state?.city ?? ""}
                      onChange={(e) => setState({ city: e.target.value })}
                    />
                  </FormControl>

                  <FormControl mt="6px !important">
                    <Input
                      label="State/District"
                      placeholder="Enter state/district"
                      value={state?.state ?? ""}
                      onChange={(e) => setState({ state: e.target.value })}
                    />
                  </FormControl>

                  <FormControl mt="6px !important">
                    <Select
                      label="Country"
                      placeholder="Select Country"
                      value={state?.country ?? ""}
                      onChange={(e) => setState({ country: e.target.value })}
                    >
                      {countries?.map((country, i) => (
                        <option key={`country-${i}`} value={country?.country}>
                          {capitalize(country.country)} ({country?.countryCode})
                        </option>
                      ))}
                    </Select>

                    <FormHelperText fontSize="sm">
                      {!isFeeLoading ? (
                        <HStack as="span">
                          <Box as="strong">Card fee ${feeData?.fee}</Box>{" "}
                          {feeData?.isInDiscountPeriod && (
                            <Badge colorScheme="purple">
                              +{feeData?.discount}
                              {feeData?.discountUnit} discount = ${fee}
                            </Badge>
                          )}
                        </HStack>
                      ) : (
                        <CircularProgress
                          isIndeterminate
                          size="14px"
                          color="green.400"
                        />
                      )}
                    </FormHelperText>
                  </FormControl>

                  <FormControl mt="20px !important">
                    <Select
                      label="Crypto Wallet (Select wallet to debit from)"
                      //   isInvalid={getBalance(state?.wallet) < 1}
                      placeholder="Select Wallet"
                      value={state?.coin ?? ""}
                      onChange={(e) => setState({ coin: e.target.value })}
                    >
                      {constant.stableCoins.map((coin) => (
                        <option key={`${coin}-wallet`} value={coin}>
                          {toCoinLocale(coin)}
                        </option>
                      ))}
                    </Select>

                    <FormHelperText fontSize="xs" color="grey">
                      Note: Delivery charges willl be commmunicated once the
                      cards are ready
                    </FormHelperText>

                    {balance < fee && (
                      <FormHelperText fontSize="xs" color="red.400">
                        Insufficient balance
                      </FormHelperText>
                    )}

                    {state?.coin && (
                      <FormHelperText fontSize="sm" color="green.400">
                        Available balance: {toPrecision(balance, state?.coin)}
                      </FormHelperText>
                    )}
                  </FormControl>

                  <Button
                    isLoading={isLoading}
                    disabled={isDisabled}
                    w="100%"
                    minH="64px"
                    mt="32px"
                    type="submit"
                  >
                    Submit
                  </Button>
                </Box>
              </VStack>
            </Box>
          </Container>
        </Box>
      </Box>

      <SuccessModal
        isOpen={isOpen}
        onClose={handleSuccessModalClose}
        title="Success"
        // message=""
      >
        <Text textAlign="center">
          Your card will be ready in a minimum of 60 days. <br /> Delivery
          charges willl be commmunicated once the cards are ready.
        </Text>
      </SuccessModal>

      <SubmitPinModal
        closeOnSubmit
        isOpen={isPinOpen}
        onClose={onPinClose}
        onPin={(pin) => setState({ pin })}
        onSubmit={handlePreorder}
      />
    </Box>
  );
}
